define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SegparReviewDomain = void 0;
    class SegparReviewDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: SegparReviewDomain.ConfirmationOfChangeRequired, value: "Confirmation of Change Required" },
                    { key: SegparReviewDomain.ConfirmationOfDeletionRequired, value: "Confirmation of Deletion Required" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[SegparReviewDomain.ConfirmationOfChangeRequired] = 0;
                this.KeyIndex[SegparReviewDomain.ConfirmationOfDeletionRequired] = 1;
                this.ValueIndex = {};
                this.ValueIndex["Confirmation of Change Required"] = 0;
                this.ValueIndex["Confirmation of Deletion Required"] = 1;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.SegparReviewDomain = SegparReviewDomain;
    Object.defineProperty(SegparReviewDomain, "ConfirmationOfChangeRequired", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "C"
    });
    Object.defineProperty(SegparReviewDomain, "ConfirmationOfDeletionRequired", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "D"
    });
    Object.defineProperty(SegparReviewDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
